export default {
  "0": {
    name: "Riyadh Bank",
    image: "https://hassad.riyadbank.com/assets/header/riyadbank.svg",
    features: ["items", "tags", "configurations", "sync"],
    baseUrl: process.env.REACT_APP_RIYADH_BASE_URL,
    transactionsEndpoint: "/Dashboard/GetTransactions",
  },
  "1": {
    name: "MoneyFellows",
    image: "https://moneyfellows.com/media/20nauxej/header-logo-png.png",
    baseUrl: process.env.REACT_APP_MONEYFELLOWS_BASE_URL,
    features: [],
    transactionsEndpoint: "/Dashboard/GetTransactions",
  },
} as Record<
  string,
  {
    name: string;
    image: string;
    features: string[];
    baseUrl?: string;
    transactionsEndpoint: string;
  }
>;
